{
  "min": -643,
  "max": -235,
  "R": [0, 0, 0],
  "G": [154, 154, 154],
  "B": [179, 179, 101],
  "A": [0, 32, 0],
  "I": [0, 163, 255]
}
